(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyUiSelectSimplebar", function () {
    return {
      restrict: "A",
      scope: true,
      link: function ($scope, $element) {
        /*
         * Usage
         * -----
         *
         * Case 1: Apply Simplebar to a <ui-select-choices> directly
         * on the page (i.e. in a *.cshtml file)
         *
         * - Add the data-ty-ui-select-simplebar attribute to that
         *   element. (Don't add data-simplebar or its companion
         *   attributes)
         *
         * Case 2: Apply Simplebar to a <ui-select-choices> INSIDE of
         * an Angular template (e.g. as we use it in year-selection.js)
         *
         * - Just use Simplebar normally -- apply the data-simplebar
         *   and its companion attributes directly on the
         *   <ui-select-choices> tag.
         */

        /*
         * How this works:
         * - We manually input the data attribute for simplebar
         * - This is needed as simplebar is loaded from the IA/Global
         *   nav in Toyota.Shared
         * - Having it automatically load in AngularJS meant it was
         *   being applied to all children elements on repeat
         */

        $element.attr("data-simplebar", "init");
        $element.attr("data-simplebar-auto-hide", "false");
      },
    };
  });
})(window.angular);
